<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧医疗统一支付云平台</div>
          <div class="subtitle"></div>
          <div class="desc">
            还在为这些问题而烦恼吗？
            <br/>
            支付渠道、场景 众多且在不断增加；现金退款对现金储备量要求大；每笔资金无法区分业务场景；
            <br/>
            智慧医疗统一支付管理平台为您提供一站式解决方案！
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="content content-about">
            <div class="about-left">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-2.png"/>
              </div>
            </div>
            <div class="about-right">
              <div class="about-title">智慧医疗统一支付云平台</div>
              <div class="about-desc">
                提供更加创新、便捷的支付场景，为患者解决付费难的问题，从而帮助医院改善患者的医疗服务，帮助医院合理“关闭”收费
                <br/>
                在提高患者支付需求满意度同时，也要妥善解决财务管理部门面临的支付改革后遗症，资金认领难、银行回款单场景划分不清，出现单边账无法找到原因、 退款原路返回结算资金等等问题，有效防控财务金融风险，减轻财务工作负担
                <br/>
                从接口对接、资金保障、信息安全等多维度为信息科提供整体的 医疗支付解决方案，确保项目高效、稳定、安全落地
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">一站式解决方案</div>
            <div class="subtitle">
              非医疗场景，无业务系统的收费我们都要“管起来”
              <br/>
              外部支付渠道增加，新的业务系统接入。 都“不受影响”
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-10.png"/>
              </div>
            </div>
          </div>
          <div class="intro-con">
            <div class="title">常见支付场景</div>
            <div class="subtitle">
              1、自助机扫码支付
            </div>
            <div class="content">
              <div class="image-single" style="height:350px">
                <img src="../../assets/images/pay/pay-3.png" style="width:45%;height:100%;float:left;"/>
                <img src="../../assets/images/pay/arrow-right.png" style="width:9%;margin-bottom:140px;" />
                <img src="../../assets/images/pay/pay-4.png" style="width:45%;height:100%;"/>
              </div>
              <div class="image-single" style="height:95px;">
                <img src="../../assets/images/pay/arrow-down.png" style="width:9%;height:91%;float:right;margin-right:160px;" />
              </div>
              <div class="image-single" style="height:350px;">
                <img src="../../assets/images/pay/pay-6.png" style="width:45%;height:100%;"/>
                 <img src="../../assets/images/pay/arrow-left.png" style="width:9%;margin-bottom:140px;" />
                <img src="../../assets/images/pay/pay-5.png" style="width:45%;height:100%;"/>
              </div>
            </div>
          </div>
          <div class="intro-con">
            <div class="subtitle">
              2、门诊窗口扫码支付
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-7.png"/>
              </div>
            </div>
          </div>
           <div class="intro-con">
            <div class="subtitle">
              3、医生诊间扫码支付
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-8.png" style="width:75%;height:500px;margin-left:150px;"/>
              </div>
            </div>
          </div>
           <div class="intro-con">
            <div class="subtitle">
              4、病区扫码支付
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-9.jpg"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">统一支付云平台优势</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-1.png"/>
                <div class="box-title">支付</div>
                <div class="box-desc">
                  1、多渠道：银联、银联商务、云闪付、支付宝、微信、建行，工行，农行等；<br/>
                  2、多场景：诊间，大堂自助机，壁挂自主机，窗口扫码，人脸付等；
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-2.png"/>
                <div class="box-title">退费</div>
                <div class="box-desc">
                  1、平台联动退款，资金原路退回；<br/>
                  2、支持多次部分退款；<br/>
                  3 、主流银行POS交易无卡免密退款；
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-3.png"/>
                <div class="box-title">统计</div>
                <div class="box-desc">
                  1、统计每日交易账单收款总金额，收款笔数，退款总金额，退款笔数；<br/>
                  2、统计每月交易账单收款总金额，收款笔数，退款总金额，退款笔数；<br/>
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-4.png"/>
                <div class="box-title">深度</div>
                <div class="box-desc">
                  1、账单分类汇总，数据可下钻；<br/>
                  2、每笔交易信息具体到某个业务场景和相对应的渠道、单号、商户号、场景名称、交易时间、交易金额等；
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product.vue